module.exports = __webpack_public_path__ + "5be7d93526a8a30f83979e70a818139e.png";